import { Form } from "semantic-ui-react";
import { AccessibleDropdown, AccessibleDropdownOption } from "../accessible/AccessibleDropdown";
import { SharedAddressFieldProps } from "./AddressFormField";
import { CountryFlag } from "../../CountryFlag";
import { FormatOptionLabelMeta } from "react-select";
import useCountries from "../../../../hooks/useCountries";
import { useId } from "react-aria";
import classNames from "classnames";

interface CountryFormFieldProps extends SharedAddressFieldProps {
  onCountryLoaded?: () => void;
  subLabelPadding?: boolean;
}

export function CountryFormField({
  disabled,
  error,
  required,
  handleChange,
  onCountryLoaded,
  value,
  subLabel,
  subLabelPadding,
}: CountryFormFieldProps) {
  const { countryDropdownOptions } = useCountries({
    onLoaded: onCountryLoaded,
  });
  const id = useId();
  const countryOptionsWithLabel = countryDropdownOptions.map(({ key, value, text }) => ({ key, value, label: text }));
  return (
    <div className='tw-w-[100px]'>
      <Form.Field className='!tw-mb-0' required={required} disabled={disabled} error={!!error}>
        <label htmlFor={id}>Country</label>
        {(subLabel || subLabelPadding) && (
          <div
            className={classNames("sub-label", {
              "tw-text-[#b2b2b2]": disabled,
            })}
          >
            {subLabel}
          </div>
        )}
        <AccessibleDropdown
          classNamePrefix='accessible-input'
          id={id}
          options={countryOptionsWithLabel}
          value={countryOptionsWithLabel.find((option) => option.value === value?.countryId) ?? null}
          onChange={(newValue) =>
            handleChange({
              countryId: (newValue && "value" in newValue ? newValue.value : "") ?? "",
            })
          }
          disabled={disabled}
          placeholder=''
          error={error}
          showErrorLabel={false}
          formatOptionLabel={(
            option: AccessibleDropdownOption,
            formatOptionLabelMeta: FormatOptionLabelMeta<AccessibleDropdownOption>,
          ) => {
            // If in the menu, show both flag and country name. If in the control, show only the flag.
            if (formatOptionLabelMeta.context === "menu") {
              return (
                <div>
                  <CountryFlag countryId={option.label} ariaHidden={true} />
                  <span>{option.label}</span>
                </div>
              );
            }
            return <CountryFlag countryId={option.label} />;
          }}
          menuDirection='left'
          menuClassName='tw-min-w-[200px]'
        />
      </Form.Field>
    </div>
  );
}
